// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"f3-z","colorTextValue":"g3-z","swatches":"h3-z","collapseLink":"i3-z","isCollapsed":"j3-z","dropdown":"k3-z","disabled":"l3-z"};